import { GMDialog } from '..';
import { useLocalization } from '../../../context/Localization/localization';
import { GMButton } from '../../Button';
import { DialogTryAgainOrOkProps } from './DialogTryAgainOrOk.types';

/**
 * A Dialog component that presents the user with a try again/ok option.
 *
 * @param ariaLabel - {@link DialogTryAgainOrOkProps.ariaLabel ariaLabel} description.
 * @param title - {@link DialogTryAgainOrOkProps.title title} description.
 * @param open - {@link DialogTryAgainOrOkProps.open open} description.
 * @param onTryAgain - {@link DialogTryAgainOrOkProps.onTryAgain onTryAgain} description.
 * @param onOk - {@link DialogTryAgainOrOkProps.onOk onOk} description.
 * @param className - {@link DialogTryAgainOrOkProps.className className} description.
 * @param children - {@link DialogTryAgainOrOkProps.children children} description.
 */
const DialogTryAgainOrOk = ({
    ariaLabel,
    title,
    className,
    open,
    onTryAgain,
    onOk,
    children,
}: DialogTryAgainOrOkProps) => {
    const Localization = useLocalization();

    return (
        <GMDialog
            ariaLabel={ariaLabel}
            title={title}
            className={className}
            open={open}
            onClose={onOk}
            actions={[
                <GMButton
                    id={Localization.TryAgain}
                    title={Localization.TryAgain}
                    ariaLabel={Localization.TryAgain}
                    onClick={onTryAgain}
                >
                    {Localization.TryAgain}
                </GMButton>,
                <GMButton
                    id={Localization.OK}
                    title={Localization.OK}
                    ariaLabel={Localization.OK}
                    onClick={onOk}
                >
                    {Localization.OK}
                </GMButton>,
            ]}
        >
            {children}
        </GMDialog>
    );
};

export default DialogTryAgainOrOk;